// extracted by mini-css-extract-plugin
export var blue = "Code-module--blue--fQCYC";
export var code = "Code-module--code--W3-CP";
export var red = "Code-module--red--01aUp";
export var root = "Code-module--root--c5R4D";